/** PC 底部导航中的版权声明模板，使用模块外层 template_id。 */
export const COPYRIGHT_TEMPLATE_ID = 4;

interface FooterCopyrightModule {
  id?: number;
  template_id?: number;
  content?: unknown;
}

interface FooterCopyrightContent {
  key: string;
  text: string;
}

/** 版权符号、年份和文案均由后台维护，空配置不补前端默认内容。 */
export function getFooterCopyrightModules(
  navList: readonly FooterCopyrightModule[],
): FooterCopyrightContent[] {
  return navList.flatMap((module, index) => {
    if (
      module.template_id !== COPYRIGHT_TEMPLATE_ID ||
      typeof module.content !== 'object' ||
      module.content === null ||
      !('text' in module.content) ||
      typeof module.content.text !== 'string'
    ) {
      return [];
    }

    const text = module.content.text.trim();
    return text ? [{ key: `${module.id ?? index}`, text }] : [];
  });
}
